
import { CreateElement } from 'vue'
import { Component, mixins } from '@niknevis/vue-modules'
import { InjectReactive, Prop } from 'vue-property-decorator'
import { RenderTd } from '@/modules/common/tes-table/components/shared/base/RenderTd'
import { isPlainObject } from '@/modules/shared/helpers/utils/utils'
import TesTableCell from '@/modules/common/tes-table/components/shared/base/TesTableCell.vue'

@Component
export default class TesTr extends mixins<RenderTd>(RenderTd) {
  @Prop() columnComponents!: Record<string, any>

  @Prop() fixedData: any

  @InjectReactive()
  tesKey!: any

  @InjectReactive()
  grid!: any

  @InjectReactive()
  pageIndex!: any

  @InjectReactive()
  row!: any

  @InjectReactive()
  cols!: any[]

  @InjectReactive()
  colsMap!: any

  @InjectReactive()
  sort!: any

  @InjectReactive()
  rowIndex!: any

  @InjectReactive()
  color!: any

  @InjectReactive()
  dark!: any

  @InjectReactive()
  dense!: any

  @InjectReactive()
  selected!: any

  @InjectReactive()
  __trClass!: string

  __getBodyCellScope(col) {
    const data = {
      col,
      key: this.tesKey,
      row: this.row,
      pageIndex: this.pageIndex,
      cols: this.cols,
      colsMap: this.colsMap,
      sort: this.sort,
      rowIndex: this.rowIndex,
      color: this.color,
      dark: this.dark,
      dense: this.dense,
      grid: this.grid,
      selected: this.selected
    }

    Object.defineProperty(data, 'value', {
      get: () => col.value,
      configurable: true,
      enumerable: true
    })

    return data
  }

  __colComponent(col) {
    return this.columnComponents[col.name]
  }

  render(h: CreateElement) {
    const
      bodyCell = this.$scopedSlots['body-cell'],
      child = this.cols.map(col => {
        const
          bodyCellCol = this.$scopedSlots[`body-cell-${col.name}`],
          slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell

        if (slot !== void 0) {
          return slot(this.__getBodyCellScope(col))
        } else if (this.__colComponent(col) || col.component) {
          const props = this.__getBodyCellScope(col)

          const colComponentValue = this.__colComponent(col)

          if (isPlainObject(colComponentValue)) {
            const colComponentValuePropHandler = colComponentValue.handler
              .bind(null, props.value, props.row, this.fixedData, props)
            return h(TesTableCell, {
              props: {
                targetComponent: colComponentValue.component,
                targetComponentProps: colComponentValuePropHandler(),
                props,
                ...props
              }
            })
          }

          const colComponent = colComponentValue || col.component
          return h(colComponent, {
            props: {
              props,
              ...props
            }
          })
        } else {
          return this.__renderTd(h, col, this.grid)
        }
      })

    const data = { key: this.tesKey, attrs: this.$attrs, on: this.$listeners }

    if (this.grid) {
      return h('div', {
        staticClass: 'q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3 border-grey q-pa-md',
        class: this.selected === true ? 'q-table__grid-item--selected' : ''
      }, [
        h('div', data, child)
      ])
    }

    return h('tr', data, child)
  }
}
